import { Landmark, ShieldCheck, BadgeCheck, Bot } from "lucide-react";
import { Reveal, SectionLabel } from "./shared";
import { useLang } from "./i18n";

const ICONS = [Landmark, ShieldCheck, BadgeCheck, Bot];

export function Trust() {
  const { t, images } = useLang();
  return (
    <section id="about" className="bg-paper py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <SectionLabel>{t.trust.label}</SectionLabel>
          <h2 className="font-display text-4xl font-semibold leading-[1.1] tracking-[-0.02em] text-ink md:text-5xl">
            {t.trust.titleA} <span className="italic text-aqua-700">{t.trust.titleB}</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.trust.items.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.07}>
                <div
                  data-testid={`trust-item-${i}`}
                  className="group h-full rounded-3xl border border-slate-200 bg-white p-7 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-aqua-600/30"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-navy text-aqua-300 transition-transform duration-300 group-hover:scale-110">
                    <Icon size={20} />
                  </span>
                  <h3 className="mt-5 font-display text-lg font-semibold text-ink">{c.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-slate-500">{c.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <div className="relative mt-16 h-64 overflow-hidden rounded-3xl md:h-80">
            <img src={images.skyline} alt={t.trust.bandAlt} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-midnight/80 via-midnight/40 to-transparent" />
            <div className="absolute inset-0 flex items-center p-8 md:p-14">
              <div>
                <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-maple">{t.trust.bandKicker}</div>
                <div className="mt-3 max-w-md font-display text-3xl font-semibold leading-tight text-white md:text-4xl">
                  {t.trust.bandTitle}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
